import React, { useState } from "react";
import { useTranslations, Autocomplete, useGraphqlQuery } from "@openimis/fe-core";

const DropDownPayrollCyclePicker = (props) => {
  const {
    onChange,
    readOnly,
    required,
    withLabel = true,
    withPlaceholder,
    value,
    label,
    filterOptions,
    filterSelectedOptions,
    placeholder,
    extraFragment,
    multiple,
  } = props;
  const [searchString, setSearchString] = useState(null);
  const { formatMessage } = useTranslations("programs");

  const { isLoading, data, error } = useGraphqlQuery(
    `query PayrollcyclePicker {
      payrollcycles {
        edges{
          node{
            uuid
            payrollCycleName
            startDate
            endDate
            scheme {
              name
              code
            }
          }
        }
      }
    }`,
    { searchString, first: 20 },
    { skip: true }
  );

  return (
    <Autocomplete
      multiple={multiple}
      required={required}
      placeholder={placeholder ?? formatMessage("payrollcyclePicker.placeholder")}
      label={label ?? formatMessage("payrollcycle.label")}
      error={error}
      withLabel={withLabel}
      withPlaceholder={withPlaceholder}
      readOnly={readOnly}
      options={data?.payrollcycles?.edges.map((edge) => edge.node) ?? []}
      isLoading={isLoading}
      value={value}
      getOptionLabel={(option) => `${option.payrollCycleName}`}
      onChange={(option) => onChange(option, option ? `${option.payrollCycleName}` : null)}
      filterOptions={filterOptions}
      filterSelectedOptions={filterSelectedOptions}
      onInputChange={setSearchString}
    />
  );
};

export default DropDownPayrollCyclePicker;